export function manyTimes(n, f) {
    const results = [];
    while (n > 0) {
        n--;
        results.push(f());
    }
    return results;
}
//# sourceMappingURL=manyTimes.js.map